import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const MKTypography = forwardRef(
  ({ color, fontWeight, textTransform, verticalAlign, textGradient, opacity, ...rest }, ref) => (
    <Typography
      ref={ref}
      sx={{
        color: color,
        fontWeight: fontWeight,
        textTransform: textTransform,
        verticalAlign: verticalAlign,
        opacity: opacity,
        ...(textGradient && {
          backgroundImage: "linear-gradient(195deg, #42424a 0%, #191919 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          position: "relative",
          zIndex: 1,
        }),
        ...rest.sx,
      }}
      {...rest}
    />
  )
);

MKTypography.defaultProps = {
  color: "dark",
  fontWeight: "regular",
  textTransform: "none",
  verticalAlign: "unset",
  textGradient: false,
  opacity: 1,
};

MKTypography.propTypes = {
  color: PropTypes.string,
  fontWeight: PropTypes.oneOf(["light", "regular", "medium", "bold"]),
  textTransform: PropTypes.oneOf(["none", "capitalize", "uppercase", "lowercase"]),
  verticalAlign: PropTypes.oneOf([
    "unset",
    "baseline",
    "sub",
    "super",
    "text-top",
    "text-bottom",
    "middle",
    "top",
    "bottom",
  ]),
  textGradient: PropTypes.bool,
  opacity: PropTypes.number,
};

MKTypography.displayName = "MKTypography";

export default MKTypography;

